import { Injectable } from '@angular/core';

import { apiName } from "./data.service";
import { RestService } from "../../../core/services/rest.service";
import { AbastecimentoBem } from "./abastecimento-bem.model";

@Injectable()
export class AbastecimentoBemApiService {

    constructor(
        private _restService: RestService
    ) { }

    onPost(object: AbastecimentoBem, done: any) {
        this._restService.onPost(apiName, object, done);
    }

    onPut(object: AbastecimentoBem, done: any) {
        this._restService.onPut(apiName, object, done);
    }

    onDelete(objectId: number, done: any) {
        this._restService.onDelete(apiName, objectId, done);
    }

    onGetAll(done: any) {
        let filter: any = {"order":"data","include":["combustivel","area","bem","local","odometroHorimetro",{"bomba":[{"tanque":"combustivel"}]},{"motorista":[{"funcionario":"pessoa"}]}]};
        this._restService.onGetPost(apiName, filter, done);
    }

    onGetById(objectId: number, done: any) {
        let filter: any = {"include":["combustivel","area","bem","local","odometroHorimetro",{"bomba":[{"tanque":"combustivel"}]},{"motorista":[{"funcionario":"pessoa"}]}]};
        this._restService.onGetPostId(apiName, objectId, filter, done);
    }

    onGetQuery(query: any, done: any) {
        this._restService.onGetPostCustom(apiName + '/populado', query, done);//busca abastecimentos
    }

    onGetApiUrl() {
        return apiName;
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/abastecimento-bens/shared/abastecimento-bem-api.service.ts
 **/